module.exports = __webpack_public_path__ + "img/clmayr.66da1941.png";